<template>
    <div
        v-if="variant === 'icon'"
        class="grid w-max grid-cols-[auto_repeat(3,_auto)] items-center gap-x-16 gap-y-4 overflow-x-auto p-4"
    >
        <span />
        <em
            v-for="size in iconButtonSizes"
            :key="`header-${size}`"
            class="justify-self-stretch text-center"
        >
            icon button – {{ size }}
        </em>

        <em class="pr-8">Default</em>
        <DsIconButton
            v-for="size in iconButtonSizes"
            :key="`default-${size}`"
            class="justify-self-center"
            :destructive
            :icon
            :onDarkBg
            :size
            :tooltipLocation
            :tooltipText="tooltipText || ''"
            @click="handleIconBtnClick(size)"
        />

        <em>Disabled</em>
        <DsIconButton
            v-for="size in iconButtonSizes"
            :key="`disabled-${size}`"
            class="justify-self-center"
            :destructive
            disabled
            :icon
            :onDarkBg
            :size
            :tooltipLocation
            :tooltipText="tooltipText || ''"
            @click="handleIconBtnClick(size)"
        />

        <em>Loading</em>
        <DsIconButton
            v-for="size in iconButtonSizes"
            :key="`loading-${size}`"
            class="justify-self-center"
            :destructive
            :icon
            loading
            :onDarkBg
            :size
            :tooltipLocation
            :tooltipText="tooltipText || ''"
            @click="handleIconBtnClick(size)"
        />
    </div>

    <div
        v-else
        class="flex items-start gap-16 overflow-x-auto p-4"
    >
        <div class="grid w-max grid-cols-[repeat(4,_auto)] items-center gap-4">
            <em class="col-span-4 justify-self-stretch text-center">{{ variant }} {{ href ? 'link' : 'button' }} – lg</em>
            <em class="pr-8">Default</em>
            <DsButton
                :destructive
                :href
                :onDarkBg
                size="lg"
                :target
                :variant
                @click="handleBtnClick('lg')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                :leading
                :onDarkBg
                size="lg"
                :target
                :variant
                @click="handleBtnClick('lg', 'leading')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                :onDarkBg
                size="lg"
                :target
                :trailing
                :variant
                @click="handleBtnClick('lg', 'trailing')"
            >
                Button CTA
            </DsButton>

            <em>Disabled</em>
            <DsButton
                :destructive
                disabled
                :href
                :onDarkBg
                size="lg"
                :target
                :variant
                @click="handleBtnClick('lg')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                disabled
                :href
                :leading
                :onDarkBg
                size="lg"
                :target
                :variant
                @click="handleBtnClick('lg', 'leading')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                disabled
                :href
                :onDarkBg
                size="lg"
                :target
                :trailing
                :variant
                @click="handleBtnClick('lg', 'trailing')"
            >
                Button CTA
            </DsButton>
            <em>Loading</em>
            <DsButton
                :destructive
                :href
                loading
                :onDarkBg
                size="lg"
                :target
                :variant
                @click="handleBtnClick('lg')"
            >
                Button CTA
            </DsButton>
        </div>

        <div class="grid w-max grid-cols-[repeat(3,_auto)] items-center justify-items-start gap-4">
            <em class="col-span-3 justify-self-stretch text-center">{{ variant }} {{ href ? 'link' : 'button' }} – md</em>
            <DsButton
                :destructive
                :href
                :onDarkBg
                size="md"
                :target
                :variant
                @click="handleBtnClick('md')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                :leading
                :onDarkBg
                size="md"
                :target
                :variant
                @click="handleBtnClick('md', 'leading')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                :onDarkBg
                size="md"
                :target
                :trailing
                :variant
                @click="handleBtnClick('md', 'trailing')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                disabled
                :href
                :onDarkBg
                size="md"
                :target
                :variant
                @click="handleBtnClick('md')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                disabled
                :href
                :leading
                :onDarkBg
                size="md"
                :target
                :variant
                @click="handleBtnClick('md', 'leading')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                disabled
                :href
                :onDarkBg
                size="md"
                :target
                :trailing
                :variant
                @click="handleBtnClick('md', 'trailing')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                loading
                :onDarkBg
                size="md"
                :target
                :variant
                @click="handleBtnClick('md')"
            >
                Button CTA
            </DsButton>
        </div>

        <div class="grid w-max grid-cols-[repeat(3,_auto)] items-center justify-items-start gap-4">
            <em class="col-span-3 justify-self-stretch text-center">{{ variant }} {{ href ? 'link' : 'button' }} – sm</em>
            <DsButton
                :destructive
                :href
                :onDarkBg
                size="sm"
                :target
                :variant
                @click="handleBtnClick('sm')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                :leading
                :onDarkBg
                size="sm"
                :target
                :variant
                @click="handleBtnClick('sm', 'leading')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                :onDarkBg
                size="sm"
                :target
                :trailing
                :variant
                @click="handleBtnClick('sm', 'trailing')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                disabled
                :href
                :onDarkBg
                size="sm"
                :target
                :variant
                @click="handleBtnClick('sm')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                disabled
                :href
                :leading
                :onDarkBg
                size="sm"
                :target
                :variant
                @click="handleBtnClick('sm', 'leading')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                disabled
                :href
                :onDarkBg
                size="sm"
                :target
                :trailing
                :variant
                @click="handleBtnClick('sm', 'trailing')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                loading
                :onDarkBg
                size="sm"
                :target
                :variant
                @click="handleBtnClick('sm')"
            >
                Button CTA
            </DsButton>
        </div>

        <div class="grid w-max grid-cols-[repeat(3,_auto)] items-center justify-items-start gap-4">
            <em class="col-span-3 justify-self-stretch text-center">{{ variant }} {{ href ? 'link' : 'button' }} - xs</em>
            <DsButton
                :destructive
                :href
                :onDarkBg
                size="xs"
                :target
                :variant
                @click="handleBtnClick('xs')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                :leading
                :onDarkBg
                size="xs"
                :target
                :variant
                @click="handleBtnClick('xs', 'leading')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                :onDarkBg
                size="xs"
                :target
                :trailing
                :variant
                @click="handleBtnClick('xs', 'trailing')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                disabled
                :href
                :onDarkBg
                size="xs"
                :target
                :variant
                @click="handleBtnClick('xs')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                disabled
                :href
                :leading
                :onDarkBg
                size="xs"
                :target
                :variant
                @click="handleBtnClick('xs', 'leading')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                disabled
                :href
                :onDarkBg
                size="xs"
                :target
                :trailing
                :variant
                @click="handleBtnClick('xs', 'trailing')"
            >
                Button CTA
            </DsButton>
            <DsButton
                :destructive
                :href
                loading
                :onDarkBg
                size="xs"
                :target
                :variant
                @click="handleBtnClick('xs')"
            >
                Button CTA
            </DsButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { TooltipPlacementType } from '@/components/design-system/design-system';
import type { DsTooltipProps } from '@/components/design-system/tooltip/tooltip.types';
import type { DsButtonProps } from '@ds/button/DsButton.vue';
import DsButton from '@ds/button/DsButton.vue';
import type { DsIconButtonProps, IconButtonSize } from '@ds/button/DsIconButton.vue';
import DsIconButton from '@ds/button/DsIconButton.vue';
import { computed, inject } from 'vue';
import { darkModeKey } from '../injection-keys';

interface DsButtonSampleProps {
    destructive?: DsButtonProps['destructive'];
    href?: DsButtonProps['href'];
    variant: DsButtonProps['variant'];
    leading?: DsButtonProps['leading'];
    trailing?: DsButtonProps['trailing'];
    icon?: DsIconButtonProps['icon'];
    tooltipText?: DsTooltipProps['tooltipText'];
    tooltipLocation?: TooltipPlacementType;
}

const props = defineProps<DsButtonSampleProps>();

const onDarkBg = inject(darkModeKey);

const iconButtonSizes: IconButtonSize[] = ['md', 'sm', 'xs'];

const icon = computed(() => props.icon ?? 'fa-solid fa-xmark');

const target = computed(() => (props.href ? '_blank' : undefined));

const handleBtnClick = (size: DsButtonProps['size'], showIcon?: 'leading' | 'trailing') => {
    const propsCopy = { ...props, size };

    if (showIcon !== 'leading') delete propsCopy.leading;
    if (showIcon !== 'trailing') delete propsCopy.trailing;

    console.log('DsButton clicked!', propsCopy);
};

const handleIconBtnClick = (size: IconButtonSize) => {
    console.log('DsIconButton clicked!', { ...props, size });
};
</script>
